import React from "react";
import { Link, Route, Routes } from "react-router-dom";
import { Paper } from "../../components/paper/paper";
import SectionHeading from "../../components/sectionHeading";
import { Decline } from "./containers/Decline";
import { DeclineInProgress } from "./containers/DeclineInProgress";
import { DeclineApplicationNotFound } from "./containers/DeclineApplicationNotFound";
import { DeclineApplicationExpired } from "./containers/DeclineApplicationExpired";
import { DeclineWrapper } from "./components/DeclineWrapper";
import environmentSettings from "@src/constants/environmentSettings";

export const DeclineRouter = ({ children }) => {
  const { companyName } = environmentSettings;

  return (
    <DeclineWrapper>
      <main>
        <Paper className="center-full">
          {children}
          <p style={{marginBottom: "10px"}}>Thank you once again for considering us.</p>
          <SectionHeading soft heading={companyName} className="secondary-header" />
        </Paper>
      </main>
    </DeclineWrapper>
  );
}